import { LifeBuoy } from 'lucide-react';

export interface AskDvaButtonProps {
  /** True while the overlay is open: the button fills navy. */
  open: boolean;
  onClick: () => void;
}

/** Header entry point: a labeled action, navy outline on white with the lifebuoy mark. */
export function AskDvaButton({ open, onClick }: AskDvaButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={open}
      className="flex h-9 shrink-0 items-center gap-2 rounded-lg border border-dvaNavy bg-white px-3 text-[13px] font-semibold text-dvaNavy transition-colors hover:bg-dvaNavy/[0.04] aria-expanded:bg-dvaNavy aria-expanded:text-white focus-visible:ring-[3px] focus-visible:ring-dvaOrange/35 focus-visible:outline-none"
    >
      <LifeBuoy className="size-4" strokeWidth={1.9} aria-hidden="true" />
      Ask DVA
    </button>
  );
}
